import { render } from "./DomainPlaceholder.vue?vue&type=template&id=9bcf1596"
const script = {}

import "./DomainPlaceholder.vue?vue&type=style&index=0&id=9bcf1596&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__